import React from 'react'

import { Row, Col } from 'react-bootstrap'

import './PageNotFound.css'

interface Props {
}
export const PageNotFound: React.FC<Props> = (props) => {

    return <Row>
        <Col className="form-container">
            <h1 className="page-title">Page Not Found</h1>
        </Col>
    </Row>

}